export default "__VITE_ASSET__7a4be116__"